// @flow
import type { ComponentType } from 'react';

function setHocDisplayName<WrapperProps, WrappedProps>(
  Wrapper: ComponentType<WrapperProps>,
  Wrapped: ComponentType<WrappedProps>
) {
  Wrapper.displayName = `${Wrapper.name}(${
    Wrapped.displayName || Wrapped.name
  })`;
}

export default setHocDisplayName;
